import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[topModalFocus]'
})
export class ModalFocusDirective implements AfterViewInit{
  modalElementfocusables = ['checkbox','button','radio','input','a','summary'];
  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    const input = this.el.nativeElement.querySelector(
      this.modalElementfocusables.join(',')
    )
    if (input) {
      setTimeout(() => {
        input.focus();
      }, 100);
    }
  }

}
